import { computed } from 'vue';
import i18n, { ZH, ZH_HK, EN } from '@/locales';

const useCurrentReactive = () => {
    const contactUs = computed(() => {
        const localeText = {
            [ZH]: '联系我们',
            [ZH_HK]: '聯繫我們',
            [EN]: 'Contact Us'
        };
    
        return localeText[i18n.locale];
    });

    const infoItemList = computed(() => {
        const getLabel = (texts) => texts[i18n.locale];
        
        return [
            {
                label: getLabel({
                    [ZH]: '公众邮箱',
                    [ZH_HK]: '公眾郵箱',
                    [EN]: 'Public Contact'
                }),
                value: 'info@dualitybiologics.com',
                icon: 'email-info'
            },
            {
                label: getLabel({
                    [ZH]: '媒体联系',
                    [ZH_HK]: '媒體聯繫',
                    [EN]: 'Media Contact'
                }),
                value: 'PR@dualitybiologics.com',
                icon: 'email-pr'
            },
            {
                label: getLabel({
                    [ZH]: '投资者联系',
                    [ZH_HK]: '投資者聯繫',
                    [EN]: 'Investor Contact'
                }),
                value: 'IR@dualitybiologics.com',
                icon: 'email-ir'
            },
            {
                label: getLabel({
                    [ZH]: '全球合作联系',
                    [ZH_HK]: '全球合作聯繫',
                    [EN]: 'Global Partnership'
                }),
                value: 'bd@dualitybiologics.com',
                icon: 'email-bd'
            },
            {
                label: getLabel({
                    [ZH]: '人力资源联系',
                    [ZH_HK]: '人力資源聯繫',
                    [EN]: 'HR Contact'
                }),
                value: 'hr@dualitybiologics.com',
                icon: 'email-hr'
            }
        ];
    });

    return {
        contactUs,
        infoItemList
    };
}

export { useCurrentReactive };